module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "综合风险视图",
      "tags": ['异动 + 请假合并打分', '谁最危险、先救谁'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.sourceOptions,
      "label": "来源"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 分档：极高 ≥55 / 高 40–54 / 中 25–39 / 低 <25，上限 100 分")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("对学生来说只有一件事：我的老师出问题了。两类影响合并到同一个学生身上，用统一口径打分排序。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.sourceRows,
      "unit": "人",
      "right-width": 130
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          异动本来就伤一次，请假又在同一个人身上反复叠加。两类叠加的学生必须走「换老师 + 时段保障 + 主动沟通」的组合处理，单做一项不够。\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.bandRows,
      "unit": "人",
      "right-width": 110
    }
  }), _vm._v(" "), (_vm.bandInsight) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v(_vm._s(_vm.bandInsight))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("综合风险榜")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v("近 " + _vm._s(_vm.days) + " 天 · 按风险分高 → 低 · 前 50 名，导出为全部")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("待处理名单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.sourceLabel))])]), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出待处理名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid
    }, [_c('td', {
      staticClass: "num t-muted"
    }, [_vm._v(_vm._s(row.rank))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "mini-badge is-new"
    }, [_vm._v("新生优先")]) : _vm._e(), _vm._v(" "), (_vm.num(row.changeCount) > 0) ? _c('span', {
      staticClass: "mini-badge is-change"
    }, [_vm._v("异动×" + _vm._s(row.changeCount))]) : _vm._e(), _vm._v(" "), (_vm.num(row.leaveCount) > 0) ? _c('span', {
      staticClass: "mini-badge is-leave"
    }, [_vm._v("请假×" + _vm._s(row.leaveCount))]) : _vm._e(), _vm._v(" "), (row.source === 'both') ? _c('span', {
      staticClass: "mini-badge is-both"
    }, [_vm._v("叠加")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.num(row.changeCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.num(row.leaveCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.num(row.innerCount) > 0
      }
    }, [_vm._v(_vm._s(_vm.num(row.innerCount) || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 6
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('span', {
      staticClass: "score-cell"
    }, [_c('span', {
      staticClass: "score-track"
    }, [_c('div', {
      style: ({
        width: Math.min(100, _vm.num(row.score)) + '%',
        background: _vm.scoreColor(row.score)
      })
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.fmtNum(row.score, 0)))])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.band)
    }, [_vm._v(_vm._s(row.band || '—'))])]), _vm._v(" "), _c('td', {
      staticClass: "t-action"
    }, [_vm._v(_vm._s(row.action || '—'))])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("当前筛选下没有纳入评分的学生")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("风险构成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("风险来源构成"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("按学生 · 两类叠加最危险")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("风险等级分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("极高 ≥55 · 高 40–54 · 中 25–39 · 低 <25")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "num"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("原老师")]), _vm._v(" "), _c('th', [_vm._v("风险来源")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("异动")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("请假")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("3h内")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("风险分")]), _vm._v(" "), _c('th', [_vm._v("等级")]), _vm._v(" "), _c('th', [_vm._v("建议动作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("打分口径")])]), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("可调，但每一项都要有业务理由。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("风险分 = 异动 + 请假 + 叠加 + 敞口 + 损失")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("异动：淘汰 / 离职 / 关闭时间 "), _c('b', [_vm._v("统一每起 10 分")])]), _vm._v(" "), _c('li', [_vm._v("异动结果修正：还没换老师 "), _c('b', [_vm._v("+6")]), _vm._v("；换完但没保住原时段 "), _c('b', [_vm._v("+4")])]), _vm._v(" "), _c('li', [_vm._v("请假：每节 3 分；"), _c('b', [_vm._v("3 小时内（含旷课）每节再加 4 分")]), _vm._v("（无代课兜底）")]), _vm._v(" "), _c('li', [_vm._v("两类叠加："), _c('b', [_vm._v("+7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('ul', [_c('li', [_vm._v("课时敞口：剩余 ≥ 40 课时 +5；20–39 课时 +3")]), _vm._v(" "), _c('li', [_vm._v("损失课次：每课次 +1")]), _vm._v(" "), _c('li', [_vm._v("上限 100 分，四舍五入取整")]), _vm._v(" "), _c('li', [_vm._v("设计意图：异动权重高于请假，因为一次异动等于关系断裂；3 小时内的请假给到接近异动的单位权重，因为它同样没有兜底")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3074d92b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactRisk.vue
// module id = 1737
// module chunks = 8